/**
 * The single, brand-free airline help desk page.
 * Paths: /reservations-help-desk and /reservations-help-desk/search
 */

export const AIRLINE_LANDINGS = [{ slug: 'airline', name: 'Airline', shortName: 'Airline', theme: 'sky' }];

export function airlinePath() {
  return '/reservations-help-desk';
}

export function airlineResultsPath(slug) {
  return `${airlinePath(slug)}/search`;
}

export function getAirlineBySlug(slug) {
  return AIRLINE_LANDINGS.find((airline) => airline.slug === slug) ?? null;
}

export function isAirlinePath(pathname) {
  return pathname.startsWith(airlinePath());
}

/** Root class list for a landing page, plus the airline's colour theme when it has one. */
export function airlineThemeClass(base, airline) {
  return airline?.theme ? `${base} swp--theme-${airline.theme}` : base;
}
